module.exports = __webpack_public_path__ + "static/media/1417950606.b6f3de4d.ttf";